import * as Contants from './mutationType'

export default {
    [Contants.SHOWLOADING](state) {
        state.showLoading = true
    },
    [Contants.HIDELOADING](state) {
        state.showLoading = false
    },
    userOption(state, info) {
        if (info.openid) {
            localStorage.setItem('Openid', info.openid)
        }
        if (info.mobile) {
            localStorage.setItem('mobile', info.mobile)
        }
        if (info.snowflakeId) {
            localStorage.setItem('SnowflakeId', info.snowflakeId)
        }
        // if (info.accessToken) {
        //     localStorage.setItem('Access-Token', info.accessToken)
        // }
        if (info.token) {
            // localStorage.setItem('showTip', 0)
            localStorage.setItem('Authorization', info.token)
        }
        let newParams = ""
        for (const key in info) {
            if(key != 'xeLoginUrl' && key != 'openid' && key != 'mobile' && key != 'token' && key != 'snowflakeId' && key != 'accessToken') {
                newParams += key+'='+info[key]+'&'
            }
        }
        window.location.replace(location.origin+location.pathname+'?'+newParams.slice(0, -1))
        // window.history.pushState({}, "", location.origin+location.pathname+'?'+newParams.slice(0, -1))
    },
    updateAppidInfo(state, data) {
        state.title = data.title;
        state.linkTitle = data.remark;
        state.linkRouter = data.url;
        state.provinceName = data.provinceName;
        state.zphUrl = data.zphUrl;
        state.agency = data.remark1;
        state.appid = data.appId;
        state.color = data.color
        state.env = data.env
        state.publicPath = state.stylePath +  data.appId + "/img/";
        if (data.appId) {
            localStorage.setItem('Appid', data.appId)
        }
    },
    updateModuleStatus(state, {
        data
    }) {
        state.moduleStatus = data;
    },
    updateAccountInfo(state,payload) {
      // payload.balance = payload.balance.toFixed(2)
      state.accountBalance = payload
      localStorage.setItem('accountId', payload.accountId)
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js